// extracted by mini-css-extract-plugin
module.exports = {"group":"Group_group__k-KdE","active":"Group_active__1NegL","head":"Group_head__2ftkV","menu":"Group_menu__2F_au","link":"Group_link__2iHRK"};